module.exports = __webpack_public_path__ + "media/assets/images/icon-regras-6b7d764457c8106b326ad34fb9ac14ad.svg";